// Set up the accessibility button
window.setUpAccessibility = () => {
    const accessibilityButton = document.querySelector("#accessibility-button");
    const accessibilityDropdown = document.querySelector("#skip-to-content-box");

    // Set aria-disabled state to "false" for screen reader accessibility
    accessibilityButton.setAttribute("aria-disabled", "false");

    // Click event handler
    accessibilityButton.addEventListener("click", () => {
        triggerAccessibilityMode(accessibilityDropdown);
    });
    // "Enter" event handler
    accessibilityButton.addEventListener("keyup", (event) => {
        event.preventDefault();
        if (event.keyCode === 13) {
            triggerAccessibilityMode(accessibilityDropdown);
        }
    });
}

// Unfocus the accessibility button and start accessibility mode
window.triggerAccessibilityMode = (accessibilityDropdown) => {
    // Set the display to none to remove accessibility focus, then re-enable the element for future use
    accessibilityDropdown.style.display = "none";
    // The dropdown has to be hidden for a brief time so that the screen reader stops focusing it
    setTimeout(() => {
        accessibilityDropdown.style.display = "block";
    }, 50);
    window.unityInstance.SendMessage("AccessibilityHTMLCreator", "EnableAccessibility");
    window.unityInstance.SendMessage("AccessibilityHTMLCreator", "EnableAccessibility");
}